export default {

    GET_ALL_TEMPLATES_REQUEST: 'GET_ALL_TEMPLATES_REQUEST',
    GET_ALL_TEMPLATES_SUCCESS: 'GET_ALL_TEMPLATES_SUCCESS',
    GET_ALL_TEMPLATES_FAILURE: 'GET_ALL_TEMPLATES_FAILURE',

    CREATE_TEMPLATE_REQUEST: 'CREATE_TEMPLATE_REQUEST',
    CREATE_TEMPLATE_SUCCESS: 'CREATE_TEMPLATE_SUCCESS',
    CREATE_TEMPLATE_FAILURE: 'CREATE_TEMPLATE_FAILURE',

  };
  